<div class="govuk-grid-row">
  <div class="govuk-grid-column-two-thirds-from-desktop">
    <h1 class="govuk-heading-xl">Sorry, there is a problem with this service</h1>
    <p>Try again later.</p>
    <p>If you need help you can <a [routerLink]="['/contact-us']">contact us</a></p>
  </div>
</div>
